import { render, staticRenderFns } from "./BrandComponentItem.vue?vue&type=template&id=47c72313&scoped=true"
import script from "./BrandComponentItem.vue?vue&type=script&lang=js"
export * from "./BrandComponentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c72313",
  null
  
)

export default component.exports